module.exports = __webpack_public_path__ + "media/images/icon/icons8-Toggle On-10618d310244a1ffa55f333761ee5f94.png";